/*
 * @Author: liudanli 565478958@qq.com
 * @Date: 2023-04-12 09:24:58
 * @LastAuthor: liudanli 565478958@qq.com
 * @LastTime: 2023-06-13 19:34:45
 * @FilePath: \bf-nuxte:\unicew-nuxt\pagePC\middleware\popoup.js
 * @Description: Do not Description
 */

export default async function ({ app, store, route }) {
  let popoupCookie = app.$cookies.get("popoupManageExpTime");
  // let userInfo = app.$cookies.get("userInfo");
  if (!popoupCookie) {
    let params = {
      pos_uri: route.path,
      query_param: route.fullPath.replace("/?", ""),
    };
    let { code, data } = await app.$popoupManage(params);
    console.log(data, "获取弹框数据");
    if (code == 200000) {
      store.commit("cart/setPopoupInfo", data.popup);
      app.$cookies.set("popoupManageExpTime", Date.now(), {
        maxAge: 60 * 5,
      });
    }
  }
}
